import { z } from 'zod';
import { Priority, RepairOrderStatus, RepairLineType } from '../enums.js';
import { paginationQuerySchema } from '../pagination.js';
import { optionalString, optionalId, optionalInt } from './common.js';
/** Ligne d'un ordre de réparation (pièce, main d'œuvre ou autre). */
export const repairOrderLineSchema = z.object({
    type: z.nativeEnum(RepairLineType).default(RepairLineType.PART),
    sparePartId: optionalId(),
    label: z.string().trim().min(1, 'Libellé requis').max(200),
    quantity: z.coerce.number().positive('Quantité invalide').max(100000).default(1),
    unitPriceCents: z.coerce.number().int().min(0),
    taxRate: z.coerce.number().min(0).max(100).default(0),
    discountCents: z.coerce.number().int().min(0).default(0),
});
export const createRepairOrderSchema = z.object({
    customerId: z.string().min(1, 'Client requis'),
    vehicleId: z.string().min(1, 'Véhicule requis'),
    mechanicId: optionalId(),
    appointmentId: optionalId(),
    priority: z.nativeEnum(Priority).default(Priority.NORMAL),
    status: z.nativeEnum(RepairOrderStatus).default(RepairOrderStatus.DRAFT),
    diagnosis: optionalString(4000),
    comments: optionalString(4000),
    mileageAtService: optionalInt({ min: 0, max: 2_000_000 }),
    lines: z.array(repairOrderLineSchema).default([]),
});
/** Signatures : data URL (image base64) — potentiellement volumineuses. */
const signatureField = z.string().max(1_500_000).optional().nullable();
export const updateRepairOrderSchema = createRepairOrderSchema.partial().extend({
    customerSignature: signatureField,
    managerSignature: signatureField,
});
export const updateRepairOrderStatusSchema = z.object({
    status: z.nativeEnum(RepairOrderStatus),
});
/** Photo d'intervention (image en data URL). */
export const createRepairPhotoSchema = z.object({
    url: z.string().min(1).max(3_000_000),
    caption: optionalString(200),
});
export const repairOrdersQuerySchema = paginationQuerySchema.extend({
    status: z.nativeEnum(RepairOrderStatus).optional(),
    vehicleId: z.string().optional(),
    customerId: z.string().optional(),
    mechanicId: z.string().optional(),
});
//# sourceMappingURL=repairOrder.js.map